import React from "react";

const Videos = () => {
  const videoSources = [
    { src: "/media/videos/unbranded-fixed.mp4", title: "Unbranded Video" },
    { src: "/media/videos/branded-fixed.mp4", title: "Branded Video" }
  ];

  return (
    <section id="videos" style={{ padding: "2rem", backgroundColor: "#fff" }}>
      <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>Property Videos</h2>
      <div style={{ display: "flex", justifyContent: "center", gap: "2rem", flexWrap: "wrap" }}>
        {videoSources.map((video, index) => (
          <div key={index} style={{ maxWidth: "500px", width: "100%" }}>
            <h3>{video.title}</h3>
            <video controls style={{ width: "100%" }}>
              <source src={video.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Videos;